export const NAME = 'inOutRegisters';
